var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGScreeningsInner.jinja');
require('./MyADGScreeningsInner.less');

module.exports = Base.extend({

    template: template,

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGScreenings/MyADGScreeningsInner.js
// module id = 230
// module chunks = 0